import axios from 'axios';
//https://elmansoory.com/api/
//http://localhost/myproject/api/
const axiosInstance = axios.create({
    baseURL: 'https://elmansoory.com/api/',
    // timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default axiosInstance;
